import "./InputGroup.css";
import type { JSX, ParentComponent } from "solid-js";
import { Show } from "solid-js";
import { HStack } from "./Stack";

type Props = {
	class?: string;
	style?: JSX.CSSProperties;
	/** Fixed content before the control (same idea as {@link SocialHandleInput}'s `prefix`). */
	prefix?: JSX.Element;
	/** Action or adornment after the control, rendered inside the field border. */
	suffix?: JSX.Element;
};

/**
 * Single bordered field: optional prefix, one native control (usually `<input>`),
 * optional suffix — e.g. a Copy button inset on the right.
 *
 * Wrap with {@link InputContainer} for labels; use a flex row beside a button
 * when the action should sit outside the field (see StarterQuestionsEditor).
 *
 * [Design System →](http://localhost:5174/component/InputGroup)
 */
export const InputGroup: ParentComponent<Props> = (props) => {
	return (
		<HStack
			spacing="small"
			align="center"
			class={`gvtui-input-group ${props.class ?? ""}`}
			style={props.style}
		>
			<Show when={props.prefix}>
				{(prefix) => (
					<span class="gvtui-input-group__prefix">{prefix()}</span>
				)}
			</Show>
			<div class="gvtui-input-group__control">{props.children}</div>
			<Show when={props.suffix}>
				{(suffix) => (
					<div class="gvtui-input-group__suffix">{suffix()}</div>
				)}
			</Show>
		</HStack>
	);
};
